import { configureStore } from '@reduxjs/toolkit'
import dataManagerReducer from './features/Data'


export default configureStore({
  reducer: {
     dataManager: dataManagerReducer
  },
})